import { React, useContext } from 'react'
import { ShopContext } from '../Context/ShopContext'
import { useParams } from 'react-router-dom'
import ProductDisplay from '../Components/ProductDisplay/ProductDisplay'
import RelatedProducts from '../Components/RelatedProducts/RelatedProducts'

const Product = () => {
  const { all_products } = useContext(ShopContext) // Changed to all_products
  const { productId } = useParams();

  // Add loading state and error handling
  if (!all_products) {
    return <div>Loading products...</div>
  }

  const product = all_products.find((e) => e.id === Number(productId))

  if (!product) {
    return <div>Product not found</div>
  }

  return (
    <div className='Product'>
      <ProductDisplay product={product} />
      <RelatedProducts product={product} /> {/* Consider passing the product for related items */}
    </div>
  )
}

export default Product